import React from 'react'
import Link from 'next/link'
import { PromoBannerButton } from '@mc/certificates-design-system'
import { useTranslation } from '@mc/i18n'
import { paths } from '@mc/paths'
import { TrackClick } from 'pages/certificates/tracking'

type ViewCourseBannerCtaProps = {
  certSlug: string
  kind?: React.ComponentProps<typeof PromoBannerButton>['kind']
  arrowTheme?: React.ComponentProps<typeof PromoBannerButton>['arrowTheme']
}

export const ViewCourseBannerCta = ({
  certSlug,
  kind,
  arrowTheme,
}: ViewCourseBannerCtaProps) => {
  const { t } = useTranslation('@mc/certificates')

  return (
    <TrackClick
      event='certificateLandingClick'
      href={paths.certificate(certSlug)}
    >
      <PromoBannerButton
        render={<Link href={paths.certificate(certSlug)} />}
        kind={kind}
        arrowTheme={arrowTheme}
        hideTextOnMobile
      >
        {t('marketingPages.common.viewCourse')}
      </PromoBannerButton>
    </TrackClick>
  )
}
